import type { CurrencyAmount } from '@omnipresentgroup/design-system';

export enum SalaryChangeRequestStatus {
  REQUESTED = 'requested',
}

export type SalaryHistoryEntry = {
  employeeId: string;
  employeeName: string;
  effectiveDate: string;
  previousSalary?: CurrencyAmount;
  newSalary?: CurrencyAmount;
  reason: string;
  status: SalaryChangeRequestStatus;
  requestedAt: string;
};
